import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import {actionParams} from "./ActionParams";

class UploadDMS extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false, showMessage: false, messageText: "", messageTitle: ""
        }
    }

    get TransferDate() {
        let now = new Date();
        let transferDate;
        if (now.getDay() > 15) {
            transferDate = now.getMonth() === 11 ? new Date(now.getFullYear() + 1, 0, 1) : new Date(now.getFullYear(), now.getMonth() + 1, 1)
        } else transferDate = new Date(now.getFullYear(), now.getMonth(), 16);
        return transferDate.toLocaleDateString();
    }

    get CommitMessage() {
        switch (this.props.documentType.ActionId) {
            case "HealthInsurance_Duplicate":
                return i18next.t(this.props.documentType.CommitMessage);
            case "HealthInsurance_ChangeCity":
                return i18next.t(this.props.documentType.CommitMessage);
            case "HealthInsurance_ChangeProg": {
                return <div>
                    <p>{i18next.t("UploadDMS_AgreementText1")}</p>
                    <p>{i18next.t("UploadDMS_AgreementText2")}</p>
                </div>;
            }
            default:
                return i18next.t(this.props.documentType.CommitMessage);
        }
    }

    componentDidMount() {
        this.setState({isDataReady: false}, this.initialize);
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.HiPolicyReq_PO_CheckPol.reset());

            let key = {ReqTypeId: this.props.documentType.ReqTypeId};
            await this.props.dispatch(this.props.HiPolicyReq_PO_CheckPol.execute(key, {newItem: true}));
            if (this.props.HiPolicyReq_PO_CheckPol.isError) {
                await this.onClose();
            } else {
                await this.props.dispatch(this.props.dataItem.reset());
                await this.props.dispatch(this.props.dataItem.initialize(key, {
                    withParams: true, newItem: true, refresh: false
                }));

                if (!this.props.dataItem.isError) {
                    this.setState({isDataReady: true});
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    onClose = () => {
        if (this.props.onClose) this.props.onClose();
    }

    onSave = (e) => {
        e.preventDefault();

        return confirm(this.CommitMessage)
            .then(() => (this.props.documentType.ActionId === "HealthInsurance_Duplicate" ? this.props.dispatch(this.props.dataItem.execute()) : this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItem_Params))))
            .then(() => {
                if (!this.props.dataItem.isError) this.setState({
                    messageText: i18next.t((this.props.dataItem.isError ? this.props.dataItem.ErrorMessage : this.props.documentType.SuccessMessage)),
                    messageTitle: this.props.dataItem.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
                    showMessage: true
                });
            })
            .catch(() => {
            });
    }

    onCancel = (e) => {
        e.preventDefault();

        if (this.props.onClose) this.props.onClose();
    }

    onMessageClose = () => {
        if (this.props.onClose) this.props.onClose()
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <button className="btn btn-regular -goahead ml1ex"
                        disabled={this.props.documentType.ActionId === "HealthInsurance_ChangeProg" && this.props.dataItem_Params.getField(0, "HiProgIntId") === null}
                        onClick={this.onSave}>{i18next.t("Send")}
                </button>
                <button className="btn btn-regular ml1ex"
                        onClick={this.onCancel}>{i18next.t("Close")}
                </button>
            </div>
        </div>)
    }

    renderParameter = (handler, parameter) => {
        const fn = parameter.Name;
        return (<div key={parameter.Name} className="row">
            <div className="col-md-3 field-title">{handler.lbl(fn)}</div>
            <div className="col-md-9">{handler.ed(fn)}</div>
        </div>)
    }

    renderGroup = (handler, group) => {
        const content = <>
            {group.Group && group.Group.map((group) => this.renderGroup(handler, group))}
            {group.Parameter && group.Parameter.map((parameter) => parameter.ShowInForm && this.renderParameter(handler, parameter))}
        </>
        if (group.Title) return (
            <PlaceholderWrapper placeholderId={group.Name} style={group.Style} canCollapse={false}
                                showSplitterLine={true}
                                title={group.Title}>
                {content}
            </PlaceholderWrapper>)
        else return (<div style={group.Style} key={group.Name}>
            {content}
        </div>)
    }

    renderParam = (handler) => {
        const actionParamInfo = actionParams.find(action => action.Id === this.props.documentType.ActionId);
        if (actionParamInfo) return (actionParamInfo.Group && actionParamInfo.Group.map((group) => this.renderGroup(handler, group)))
        else {
            return (<div className="row">
                <div className="col-md-12">
                    {handler.fs.map((fi) => {
                        const fn = fi.Name;
                        return (<React.Fragment key={fn}>
                            <div className="row">
                                <div className="col-md-3 field-title">
                                    {handler.lbl(fn)}
                                </div>
                                <div className="col-md-9">
                                    {handler.ed(fn)}
                                </div>
                            </div>
                            <hr/>
                        </React.Fragment>)
                    })}
                </div>
            </div>)
        }
    }

    render() {
        if (!this.props.documentType || !this.state.isDataReady) return null;
        return (
            <PopupWrapper popupVisible={true} title={i18next.t(this.props.documentType.Title)} onClose={this.onClose}
                          showInstruction={false}
                          renderButtons={this.renderButtons} minHeightBody='200px'>
                <MessageBox visible={this.state.showMessage}
                            title={this.state.messageTitle}
                            messageText={this.state.messageText}
                            onClose={this.onMessageClose}/>
                {this.props.documentType.ActionId !== "HealthInsurance_Duplicate" &&
                    <PlaceholderWrapper placeholderId={this.props.documentType.ActionId + "_Body"}
                                        canCollapse={false}
                                        showSplitterLine={false}
                                        title={`${this.props.documentType.Title} - ${i18next.t("Old_Variant")}`}
                                        showHeaderTitle={false}>
                        <ComplexParam dataItem={this.props.dataItem_Params}
                                      parentDataItem={this.props.dataItem}
                                      showApplyButton={false} showSearchBar={false}
                                      rootPath="/"
                                      renderParams={this.renderParam}
                        />
                    </PlaceholderWrapper>}
            </PopupWrapper>)
    }
}

UploadDMS.propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    documentType: PropTypes.object.isRequired,
    dataItem: PropTypes.object,
    dataItem_Params: PropTypes.object
}

UploadDMS.defaultProps = {};

function mapStateToProps(state, ownProps) {
    function getDataItem(isParamSet) {
        switch (ownProps.documentType.ActionId) {
            case "HealthInsurance_Duplicate":
                return isParamSet ? state.privateDocumentsState.HiPolicyReq_PO_CreateReq_Duplicate_Params : state.privateDocumentsState.HiPolicyReq_PO_CreateReq_Duplicate;
            case "HealthInsurance_ChangeCity":
                return isParamSet ? state.privateDocumentsState.HiPolicyReq_PO_CreateReq_ChangeCity_Params : state.privateDocumentsState.HiPolicyReq_PO_CreateReq_ChangeCity;
            case "HealthInsurance_ChangeProg":
                return isParamSet ? state.privateDocumentsState.HiPolicyReq_PO_CreateReq_ChangeProg_Params : state.privateDocumentsState.HiPolicyReq_PO_CreateReq_ChangeProg;
            default:
                return;
        }
    }

    return {
        dataItem: getDataItem(false),
        dataItem_Params: getDataItem(true),
        HiPolicyReq_PO_CheckPol: state.privateDocumentsState.HiPolicyReq_PO_CheckPol,
        HiPolicyCard_PO_GetCurPol: state.privateDocumentsState.HiPolicyCard_PO_GetCurPol
    }
}

export default connect(mapStateToProps)(UploadDMS)